import { invariant } from '@ifixit/helpers';
import { IFixitAPIClient } from '@ifixit/ifixit-api-client';
import { captureException } from '@ifixit/sentry';
import type { LanguageCode } from './languages';
import type { LocaleCode } from './types';

export async function setLocalePreference(
   client: IFixitAPIClient,
   newLocale: LocaleCode
): Promise<void> {
   try {
      invariant(newLocale, 'newLocale cannot be a falsy');
      await client.post('store/user/locale_preference', 'set-locale-preference', {
         body: JSON.stringify({ newLocale }),
      });
   } catch (error) {
      console.error(error);
      captureException(error, { extra: { message: 'Failed to set locale preference' } });
   }
}

/**
 * Set the user's language preference on the PHP side.
 * This ensures PHP pages (wikis, guides) serve the right language
 * when users navigate from Next.js to PHP.
 */
export async function setLanguagePreference(
   client: IFixitAPIClient,
   languageCode: LanguageCode
): Promise<void> {
   try {
      await client.post('user/setLanguagePreferences', 'set-language-preference', {
         body: JSON.stringify({ langid: languageCode }),
      });
   } catch (error) {
      console.error(error);
      captureException(error, {
         extra: { message: 'Failed to set language preference' },
      });
   }
}
